<template>
  <!-- eslint-disable -->
  <div>
    <b-overlay variant="white" :show="showLoading" spinner-variant="primary" blur="0" opacity=".75" rounded="sm">
      <detalle-filters ref="filtersModel" />
      <b-card no-body class="mb-0">
        <b-table
          class="position-relative"
          :hover="true"
          :items="records"
          responsive
          :fields="fields"
          show-empty
          empty-text="No existen"
          @sort-changed="sortChanged"
        >
          <template #cell(actions)="data">
            <b-button
              size="sm"
              class=""
              v-b-tooltip.hover.top="'Eliminar'"
              @click="deleteAction(data)"
              variant="flat-danger"
            >
              <feather-icon icon="Trash2Icon" />
            </b-button>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col sm="3">
              <b-form-group label-cols="4" label-cols-md="4" label-size="md" label="Entradas" label-for="input-md">
                <b-form-select
                  v-model="showEntrie"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="title"
                  :options="entries"
                  @change="changeSizePage"
                />
              </b-form-group>
            </b-col>
            <b-col sm="3" class="mt-75" style="font-size: 12px">
              <span> {{ totalElements }} Registros en total</span>
            </b-col>
            <!-- Pagination -->
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalElements"
                :per-page="showEntrie"
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
                @change="cambioPagina"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from 'vue'
import detalleFilters from './detalleNacionalFilters.vue'
import { BootstrapVue, BootstrapVueIcons, VBTooltip } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import DetailNationalService from '@/services/DetailNationalService'
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
export default {
  directives: {
    'b-tooltip': VBTooltip,
    Ripple
  },
  data() {
    return {
      showLoading: false,
      records: [],
      fields: [
        { key: 'autopart.uniqueCode', label: 'Código Único', sortable: true},
        { key: 'autopart.originalCode', label: 'Código Original', sortable: true},
        { key: 'autopart.alterCode', label: 'Código alternativo', sortable: true},
        { key: 'autopart.AutopartBrand.name', label: 'Marca', sortable: true},
        { key: 'autopart.description', label: 'Autoparte', sortable: false},
        { key: 'qty', label: 'Cantidad', sortable: false },
        { key: 'retailPrice', label: 'Precio', sortable: false },
        { key: 'actions', label: 'Acciones' }
      ],
      form: {
        id: null,
        name: ''
      },
      arrayFilters: [],
      currentPage: 1,
      entries: [10, 20, 50, 100],
      showEntrie: 10,
      totalElements: 0,
      id: 0,
      sort: 'id',
      order: 'desc'
    }
  },
  components: {
    detalleFilters
  },
  mounted() {
    this.getData()
  },
  methods: {
    
    cambioPagina(e) {
      this.currentPage = e
    },
    changeSizePage() {
      this.getData()
    },
    sortChanged(data) {
      this.sort = data.sortBy
      if (data.sortDesc) {
        this.order = 'desc'
      } else this.order = 'asc'
    },
    async getData() {
      this.records = []
      this.totalElements = 0
      this.showLoading = true
      console.log("ID DEL IMPORTE",this.$route.params.id)
      const importId = parseInt(this.$route.params.id)
      const resp = await DetailNationalService.getDetailxNational(importId, this.$store)
      console.log('resp getdata', resp)

      if (resp.data) {
        console.log('resp data', resp)
        this.records = resp.data.rows
        console.log('records', this.records)
        this.totalElements = resp.data.responseFilter?.total_rows || 0;
      }
      this.showLoading = false
    },
    async deleteAction(data) {
      this.$swal({
        title: '¿Desea eliminar este detalle?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Si, eliminalo',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1'
        },
        buttonsStyling: false
      }).then((result) => {
        if (result.value) {
          this.currentPage = 1
          this.$swal({
            icon: 'success',
            title: 'Eliminado!',
            text: 'El detalle ha sido eliminado.',
            customClass: {
              confirmButton: 'btn btn-success'
            }
          })
          this.deleteData(data.item.id)
        }
      })
    },
    async deleteData(id) {
      console.log('id del DETALLE', id)
      const resp = await DetailNationalService.deleteDetail(id, this.$store)
      console.log('resp delete', resp)
      if (resp) {
        this.getData()
      } else {
        this.$swal({
          icon: 'error',
          title: 'Error',
          text: 'Ocurrió un error al eliminar el detalle.',
          customClass: {
            confirmButton: 'btn btn-success'
          }
        })
      }
      console.log('respDelete', resp)
    }
  }
}
</script>

<style></style>
